import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getRelayApi} from '../api/relay-api';
import {relayKeys} from '../query-keys';
import type {ThreadListResponse} from '../types/relay-types';

export function useAllThreads(limit = 50) {
  const tenantId = useRequiredTenantId();
  const api = getRelayApi();

  return useQuery<ThreadListResponse>({
    queryKey: relayKeys.threads.all(tenantId),
    queryFn: async () => api.getAllThreads({limit}),
  });
}
